import { Input } from "antd";
import styled from "styled-components";
const SearchInput = styled(Input)`
  width: 100%;
  border-radius: 10px;
`;

export { SearchInput };
